import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
  { path: '/homepage', label: 'Home', icon: 'Home' },
  { path: '/about-project', label: 'About', icon: 'Info' },
  { path: '/thematic-trails-overview', label: 'Trails', icon: 'Map' },
  { path: '/heritage-interactive-map', label: 'Heritage Map', icon: 'MapPin' },
  { path: '/tourism-offerings', label: 'Tourism', icon: 'Building' },
  { path: '/contact-and-partners', label: 'Contact', icon: 'Phone' }];


  const isActivePath = (path) => {
    return location?.pathname === path || location?.pathname?.startsWith(path);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-navigation bg-primary shadow-lg">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo Section */}
          <div className="flex items-center">
            <Link
              to="/homepage"
              className="flex items-center space-x-3 text-primary-foreground hover:opacity-90 transition-opacity duration-fast"
              onClick={closeMobileMenu}>

              <div className="flex h-8 w-8 items-center justify-center">
                <img
                  src="https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763227262/creativna_twinning_gp3fz0.png"
                  alt="Creative Twinning Logo"
                  className="h-15 w-15 object-contain" />

              </div>
              <div className="hidden sm:block">
                <h1 className="font-heading font-semibold text-lg leading-tight">
                  Creative Twinning
                </h1>
                <p className="text-xs text-primary-foreground/80 font-caption">
                  Kreativna Saradnja
                </p>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-1">
              {navigationItems?.map((item) =>
              <Link
                key={item?.path}
                to={item?.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-all duration-fast ${
                isActivePath(item?.path) ?
                'bg-accent text-accent-foreground shadow-sm' :
                'text-primary-foreground hover:bg-secondary hover:text-secondary-foreground'}`
                }>

                  <div className="flex items-center space-x-2">
                    <Icon name={item?.icon} size={16} />
                    <span>{item?.label}</span>
                  </div>
                </Link>
              )}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleMobileMenu}
              className="text-primary-foreground hover:bg-secondary"
              aria-label="Toggle mobile menu">

              <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
            </Button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen &&
        <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-primary border-t border-secondary/20">
              {navigationItems?.map((item) =>
            <Link
              key={item?.path}
              to={item?.path}
              onClick={closeMobileMenu}
              className={`block px-3 py-2 rounded-md text-base font-medium transition-all duration-fast ${
              isActivePath(item?.path) ?
              'bg-accent text-accent-foreground shadow-sm' :
              'text-primary-foreground hover:bg-secondary hover:text-secondary-foreground'}`
              }>

                  <div className="flex items-center space-x-3">
                    <Icon name={item?.icon} size={20} />
                    <span>{item?.label}</span>
                  </div>
                </Link>
            )}
            </div>
          </div>
        }
      </nav>
    </header>);

};

export default Header;